import React from 'react';
import cn from 'classnames';
import Button from 'components/Button';
import classes from './Elements.module.scss';

export const NightAssistButton = ({
  className,
  onClick,
  text,
  hideIcon,
  size = 'medium',
}) => {
  return (
    <Button
      type="primary"
      onClick={onClick}
      htmlType="button"
      size={size}
      className={cn(classes.nightAssistBtn, className)}
    >
      {!hideIcon && <span className="material-icons">nightlight_round</span>}
      <span className={classes.buttonText}>{text || 'Night Assist'}</span>
    </Button>
  );
};
export const NightAssistButtonMobile = ({ className, onClick }) => {
  return (
    <Button
      type="default"
      onClick={onClick}
      htmlType="button"
      isDanger
      isGhost
      size="large"
      className={cn(classes.nightAssistBtnMobile, className)}
    >
      <span className={classes.buttonText}>Night Assist</span>
    </Button>
  );
};
